import { NavLink, Link, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { LOGOS } from '../cdn';

const LINKS = [
  { to: '/', label: 'Home' },
  { to: '/features', label: 'Features' },
  { to: '/pricing', label: 'Pricing' },
  { to: '/docs', label: 'Docs' },
  { to: '/help', label: 'Help' },
  { to: '/about', label: 'About' },
  { to: '/account', label: 'Account' },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => { setOpen(false); }, [loc.pathname]);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-200 ${
        scrolled ? 'backdrop-blur-lg bg-[color:var(--color-bg)]/85 border-b border-[color:var(--color-line)]' : 'bg-[color:var(--color-bg)]/0'
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-5 h-16 flex items-center gap-3 sm:gap-4">
        <Link to="/" className="flex items-center gap-2.5 group" aria-label="Vpnee home">
          <motion.span
            whileHover={{ rotate: -6, scale: 1.05 }}
            className="w-9 h-9 rounded-xl overflow-hidden bg-[color:var(--color-bg)] ring-1 ring-[color:var(--color-brand)]/30 shadow-lg shadow-[color:var(--color-brand)]/20 grid place-items-center"
          >
            <img src={LOGOS.vpnee} alt="" width={36} height={36} className="w-full h-full object-cover" />
          </motion.span>
          <span className="font-[family-name:var(--font-display)] text-xl font-extrabold tracking-tight">Vpnee</span>
        </Link>

        <nav className="ml-auto hidden md:flex items-center gap-1" aria-label="Primary">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                `px-3 py-2 rounded-lg text-sm font-medium transition ${
                  isActive
                    ? 'text-white bg-white/5'
                    : 'text-[color:var(--color-ink-dim)] hover:text-white hover:bg-white/5'
                }`
              }
              end={l.to === '/'}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <Link to="/download" className="hidden md:inline-flex btn btn-primary ml-2 !py-2 !px-4 !text-sm">
          Get Vpnee
        </Link>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden ml-auto w-10 h-10 grid place-items-center rounded-lg border border-[color:var(--color-line)] bg-white/5"
          aria-expanded={open}
          aria-label="Toggle menu"
        >
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
            {open ? <path d="M6 6l12 12M18 6L6 18" /> : <><path d="M4 7h16" /><path d="M4 12h16" /><path d="M4 17h16" /></>}
          </svg>
        </button>
      </div>

      {open && (
        <motion.div
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          className="md:hidden border-t border-[color:var(--color-line)] backdrop-blur-lg bg-[color:var(--color-bg)]/95"
        >
          <div className="px-4 sm:px-5 py-3 flex flex-col gap-1">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === '/'}
                className={({ isActive }) =>
                  `px-3 py-2.5 rounded-lg text-sm font-medium transition ${
                    isActive ? 'text-white bg-white/5' : 'text-[color:var(--color-ink-dim)] hover:text-white hover:bg-white/5'
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/download" className="btn btn-primary mt-2 justify-center">
              Get Vpnee
            </Link>
          </div>
        </motion.div>
      )}
    </header>
  );
}
